import type { DialNumberEventPublisher } from '@usecases/dial-number.usecase';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import type { Call } from '@entities/call';
import { Logger } from '@main/utils/logger';

export class DialNumberPublisher implements DialNumberEventPublisher {
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish({ from, to }: Call): Promise<void> {
    const busIframe = await BusIframe.getIframe();

    const busEvent: BusEvent = {
      type: 'DIALER.DIAL',
      payload: {
        from,
        to,
      },
    };
    this.logger.info('Publisher: Dialing number', {
      action: 'DialNumber',
      to,
      from,
    });

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
